
<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" @showLoading="showLoading = true" @closeLoading="showLoading = false"/>
    <vx-card>

      <div class="vx-row">
        <div class="vx-col w-full mb-base text-right">
          <vs-button type="line" line-origin="left" color="danger" class="mr-5"  @click="filterFildes()">
              <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" v-if="!filter" /> <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4" v-if="filter" /> Filtrer
          </vs-button>
          <vs-button type="line" line-origin="left" color="success"  @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Ajouter nouveau
          </vs-button>
        </div>
      </div>

      <div class="vx-row w-full mb-2" v-if="filter">
        <div class="vx-col md:w-1/6 w-full">
          <vs-input label="Nom & prénom" v-model="f_name" class="mr-1 w-full" />
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <vs-input label="Company" v-model="f_company" class="mr-1 w-full" />
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <vs-input label="Télephones" v-model="f_tel" class="mr-1 w-full" />
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <vs-input label="Email" v-model="f_email" class="mr-1 w-full" />
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <vs-input name="city" label="Ville" v-model="f_city" class="mr-1 w-full" />
        </div>

        <div class="vx-col md:w-1/6 w-full">
          <vs-input label="Code postal" v-model="f_zipcode" class="mr-1 w-full" />
        </div>

      </div>

      <vs-table ref="table"  v-model="selected" pagination :max-items="itemsPerPage" :data="filteredItems" noDataText="Aucun client trouvé">

        <div slot="header" class="flex-grow ">

        </div>

        <template slot="thead">
          <vs-th sort-key="lastname">Noms & Prénoms</vs-th>
          <vs-th sort-key="company">Company</vs-th>
          <vs-th sort-key="tel">Télephones</vs-th>
          <vs-th sort-key="email">Mail</vs-th>
          <vs-th sort-key="adresse">Ville</vs-th>
          <vs-th sort-key="siret">Code postal</vs-th>

          <vs-th>Action</vs-th>
        </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td>
                  <p @click.stop="editData(tr)">{{ tr.lastname }} {{ tr.firstname }}</p>
                </vs-td>

                  <vs-td>
                  <p>{{ tr.company }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.tel }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.email }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.city }}</p>
                </vs-td>

                <vs-td>
                  <p>{{ tr.zipcode }}</p>
                </vs-td>





                <vs-td class="whitespace-no-wrap">
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="editData(tr)"/>
                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="deleteData(tr.id)"/>
                </vs-td>

              </vs-tr>
            </tbody>
          </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import DataViewSidebar from './AddUpdateSidebar'
import vSelect from 'vue-select'


import { mapGetters, mapActions } from "vuex"

export default {
  components: {
    DataViewSidebar,
    vSelect
  },
  data() {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      // Loading
      showLoading: false,

      filter : false,
      f_name: "",
      f_company: "",
      f_tel: "",
      f_email: "",
      f_city: "",
      f_zipcode: "",

    }
  },
  computed: {
    ...mapGetters('clients', { 'data' : 'GET_ITEMS' }),
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.data.length
    },
    filteredItems() {
      let dataFilter = this.data

      if(this.f_name != null && this.f_name != "") {
        dataFilter = dataFilter.filter(item => {
          return item.lastname.trim().toLowerCase().concat(' ',item.firstname.trim().toLowerCase()).includes(this.f_name.toLowerCase()) || item.firstname.trim().toLowerCase().concat(' ',item.lastname.trim().toLowerCase()).includes(this.f_name.toLowerCase())
        })
      }

      if(this.f_company != null && this.f_company != "") {
        dataFilter = dataFilter.filter(item => {
          return item.company ? item.company.toLowerCase().includes(this.f_company.toLowerCase()) : false
        })
      }

      if(this.f_tel != null && this.f_tel != "") {
        dataFilter = dataFilter.filter(item => {
          return item.tel ? item.tel.toLowerCase().includes(this.f_tel.toLowerCase()) : false
        })
      }

      if(this.f_email != null && this.f_email != "") {
        dataFilter = dataFilter.filter(item => {
          return item.email ? item.email.toLowerCase().includes(this.f_email.toLowerCase()) : false
        })
      }

      if(this.f_city != null && this.f_city != "") {
        dataFilter = dataFilter.filter(item => {
          return item.city ? item.city.toLowerCase().includes(this.f_city.toLowerCase()) : false
        })
      }

      if(this.f_zipcode != null && this.f_zipcode != "") {
        dataFilter = dataFilter.filter(item => {
          return item.zipcode ? item.zipcode.toString().toLowerCase().includes(this.f_zipcode.toString().toLowerCase()) : false
        })
      }

      return dataFilter
    }
  },
   watch: {
     showLoading (val) {
      if(val == true){
        this.$vs.loading({type: 'radius', color: '#be092f'})
      }else{
        this.$vs.loading.close()
      }
    }
  },
  methods: {
    ...mapActions('clients', ['fetchItems','removeItem']),
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    editData(data) {

    this.sidebarData = data
      this.toggleDataSidebar(true)

    },
    deleteData(data) {
      this.$swal({
        title: 'Êtes-vous sûr?',
        text: "Vous ne pourrez pas revenir en arrière",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.showLoading = true
          this.removeItem(data).then(()=>{
              this.successMsg('Suppression','L\'artisan est bien supprimé');
          }).catch(()=>{
             this.error('Suppression','error au moment suppression')
          })
          this.showLoading = false;
        }
      });
    },
    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },
    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },
    filterFildes() {
      this.filter = !this.filter
      if(!this.filter) {
        this.f_name = ""
        this.f_company = ""
        this.f_tel = ""
        this.f_mail = ""
        this.f_vile = ""
        this.f_zip_code = ""
      }
    },
  },
  created() {
    if(!this.data.length)  this.fetchItems()
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">

</style>
